import { render, staticRenderFns } from "./CoreItemThree.vue?vue&type=template&id=043cd897&scoped=true"
import script from "./CoreItemThree.vue?vue&type=script&lang=js"
export * from "./CoreItemThree.vue?vue&type=script&lang=js"
import style0 from "./CoreItemThree.vue?vue&type=style&index=0&id=043cd897&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043cd897",
  null
  
)

export default component.exports